import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardId].boardId
}

export default createSelector(
  [
    getBoardId
  ],
  (
    boardId
  ) => ({
    boardId
  })
)
